export default __webpack_public_path__ + "static/media/programming-skills.d19983a9.svg";